<script>
import Form from '../Form.vue';

export default {
  props: {
    isModalVisible: {
      type: Boolean,
      required: true
    },
    topbarControls: {
      type: Object,
      required: true
    },
    toggleModal: {
      type: Function,
      required: true
    }
  },
  components: {
    Form
  },
  data() {
    return {
      showModal: this.isModalVisible,
      formData: null
    }
  },
  watch: {
    isModalVisible(val) {
      return this.showModal = val;
    },
    topbarControls: {
      handler: function () {
        this.setFormData()
      },
      deep: true
    },
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('modal-center');
      this.setFormData()
    },
    hideModal() {
      this.$bvModal.hide('modal-center');
      this.toggleModal();
      this.setFormData()
    },
    setFormData() {
      let temp = {};
      Object.keys(this.topbarControls.config.addNewModal.form).map(function(key) {
        Object.assign(temp, {[key]: ''})
      });  
      this.formData = temp
    }
  },
  mounted() {
    this.setFormData()
  }
};
</script>
<template>
    <b-modal
      v-model="showModal"
      style="letter-spacing: 2em;"
      id="modal-center"
      centered
      :title="topbarControls.config.addNewModal.title"
      title-class="font-18"
      hide-footer
      @hidden="hideModal"
    >
    <Form
      :form="topbarControls.config.addNewModal.form"
      :data="formData"
      :topbarControls="topbarControls"
      :variant="topbarControls.config.addNewModal.variant"
      :closeModal="closeModal"
    />
    </b-modal>
</template>